import { WarningCircle } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

/**
 * What a list, panel or report shows when its data failed to load.
 *
 * Without it a failed request falls through to the empty state, and the screen says "No outstanding
 * fees", "No activity found" or "all caught up" — a connection problem presented as good news.
 */
export function QueryErrorState({
  what,
  onRetry,
  compact = false,
}: {
  /** Plain noun for the thing that failed, e.g. "activity", "this report". */
  what: string;
  onRetry?: () => void;
  /** Tighter spacing for small panels and table rows. */
  compact?: boolean;
}) {
  return (
    <div
      role="alert"
      className={`flex flex-col items-center justify-center text-center ${compact ? 'py-4' : 'py-12'}`}
    >
      <WarningCircle className={`${compact ? 'mb-1 h-5 w-5' : 'mb-2 h-8 w-8'} text-amber-500`} />
      <p className="text-sm font-medium text-foreground">Couldn't load {what}</p>
      <p className="mt-0.5 text-xs text-muted-foreground">
        This is a connection problem — it does not mean there is nothing here.
      </p>
      {onRetry && (
        <Button className="mt-3" variant="outline" size="sm" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
